import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const query = graphql`
  query {
    placeholderImage: file(relativePath: { eq: "feather.png" }) {
      relativePath
      name
      childImageSharp {
        fixed(width: 46, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const FeatherImage = ({ alt, className }) => {
  const data = useStaticQuery(query)

  return (
    <Img
      fixed={data.placeholderImage.childImageSharp.fixed}
      alt={alt}
      className={className}
    />
  )
}

export default FeatherImage
